export default "__VITE_ASSET__2bf569ed__"